import type { ModelsData, ModelData } from '../types'
import type { Category } from './CategoryGrid'

interface ModelGridProps {
  modelsData: ModelsData
  category: Category
  onModelSelect: (model: ModelData, groupKey: string, modelKey: string) => void
  onBackToCategories: () => void
}

const ModelGrid = ({ modelsData, category, onModelSelect, onBackToCategories }: ModelGridProps) => {
  
  // Collect all models from category groups
  const models = category.groups.reduce((acc, groupKey) => {
    const groupModels = modelsData[groupKey] || {}
    Object.entries(groupModels).forEach(([modelKey, modelData]) => {
      acc.push({
        model: modelData,
        groupKey,
        modelKey
      })
    })
    return acc
  }, [] as Array<{ model: ModelData, groupKey: string, modelKey: string }>)

  const formatSpecs = (model: ModelData): string => {
    const specs = []
    if (model.specs.power) specs.push(model.specs.power)
    if (model.specs.efficiency) specs.push(`Sprawność: ${model.specs.efficiency}`)
    if (model.specs.energyClass) specs.push(`Klasa: ${model.specs.energyClass}`)
    if (model.specs.insertSize) specs.push(`Wymiary: ${model.specs.insertSize}`)
    return specs.join(' • ')
  }

  return (
    <div className="model-grid-container">
      <div className="model-header">
        <button 
          className="back-button"
          onClick={onBackToCategories}
        >
          Powrót do kategorii
        </button>
      </div>
      
      <div className="model-grid">
        {models.map(({ model, groupKey, modelKey }) => (
          <div
            key={`${groupKey}-${modelKey}`}
            className="model-tile"
            onClick={() => onModelSelect(model, groupKey, modelKey)}
          >
            <div className="model-image">
              <img 
                src={model.image || 'images/unico-logo.png'} 
                alt={model.name}
                onError={(e) => {
                  e.currentTarget.src = 'images/unico-logo.png'
                }}
              />
              <div className="model-hover-description">
                <div className="model-specs-hover">
                  {formatSpecs(model)}
                </div>
              </div>
            </div>
            <div className="model-label">
              <div className="model-label-header">
                <h4>{model.name}</h4>
                <button 
                  className="model-info-icon"
                  onClick={(e) => {
                    e.stopPropagation()
                    const tile = e.currentTarget.closest('.model-tile')
                    if (tile) {
                      tile.classList.toggle('show-description')
                    }
                  }}
                  title="Zobacz opis"
                >
                  i
                </button>
              </div>
              <div className="model-power">{model.specs?.power || ''}</div>
            </div>
          </div>
        ))}
      </div>
      
      {models.length === 0 && (
        <div className="no-models">
          <p>Brak dostępnych modeli w tej kategorii</p>
        </div>
      )}
    </div>
  )
}

export default ModelGrid